import { ErrorMessage } from '@src/components/ErrorMessage';
import { RecaptchaV2 } from '@src/components/RecaptchaV2';
import { SubmissionErrorMessage } from '@src/components/SubmissionErrorMessage';
import { SubmissionStatus } from '@src/components/SubmissionStatus';


const COMPANY_SIZE_OPTIONS = [
  '-',
  '1-50 Employees',
  '51-200 Employees',
  '201-1000 Employees',
  '1001-5000 Employees',
  '5000+ Employees',
];

const INDUSTRY = [
  '-',
  'Financial Services',
  'Healthcare',
  'Education',
  'Government',
  'Manufacturing',
  'Technology',
  'Other',
];


export function DemoForm({
  formData,
  handleInputChange,
  errors,
  clearError,
  mutation,
  submissionStatus,
  setSubmissionStatus,
  csrfHookInfo,
  recaptchaError,
  setRecaptchaError,
  setRecaptchaResetFunc,
  handleSubmit,
}) {

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <div className="inline-flex items-center bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
          Ready to See BOSSS in Action?
        </div>

        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Schedule Your BOSSS Demo
        </h1>

        <p className="text-xl text-gray-600">
          Experience how BOSSS can transform your
          cybersecurity operations with unified platform
          capabilities across all security domains.
        </p>
      </div>

      <SubmissionErrorMessage
        csrfHookInfo={csrfHookInfo}
        submissionError={mutation.error}
        submissionStatus={mutation.status}
      />

      <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
        <form className="space-y-6" onSubmit={handleSubmit}>
          {/* Loading/Status Indicator */}
          <SubmissionStatus csrfHookInfo={csrfHookInfo} submissionStatus={submissionStatus} setSubmissionStatus={setSubmissionStatus} />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                First Name *
              </label>

              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                onChange={(e) => {
                  handleInputChange('first_name', e.target.value);
                  clearError('first_name');
                }}
              />

              <ErrorMessage error={errors.first_name} />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Last Name *
              </label>

              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                onChange={(e) => {
                  handleInputChange('last_name', e.target.value);
                  clearError('last_name');
                }}
              />

              <ErrorMessage error={errors.last_name} />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Work Email *
            </label>

            <input
              type="email"
              name="email"
              value={formData.email}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              onChange={(e) => {
                handleInputChange('email', e.target.value);
                clearError('email');
              }}
            />

            <ErrorMessage error={errors.email} />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Company *
            </label>

            <input
              type="text"
              name="company"
              value={formData.company}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              onChange={(e) => {
                handleInputChange('company', e.target.value);
                clearError('company');
              }}
            />

            <ErrorMessage error={errors.company} />
          </div>


          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Company Size
              </label>

              <select
                name="company_size"
                value={formData.companySize}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                onChange={(e) => {
                  handleInputChange('company_size', e.target.value);
                  clearError('company_size');
                }}
              >
                {COMPANY_SIZE_OPTIONS.map((size) => (
                  <option key={size} value={size}>{size}</option>
                ))}
              </select>

              <ErrorMessage error={errors.company_size} />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Industry
              </label>

              <select
                name="industry"
                value={formData.industry}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                onChange={(e) => {
                  handleInputChange('industry', e.target.value);
                  clearError('industry');
                }}
              >
                {INDUSTRY.map((size) => (
                  <option key={size} value={size}>{size}</option>
                ))}
              </select>

              <ErrorMessage error={errors.industry} />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              What BOSSS modules are you most interested in?
            </label>

            <textarea
              rows={4}
              name="modules_of_interest"
              value={formData.modulesOfInterest}
              placeholder="Tell us about your cybersecurity and compliance challenges..."
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              onChange={(e) => {
                handleInputChange('modules_of_interest', e.target.value);
                clearError('modules_of_interest');
              }}
            />

            <ErrorMessage error={errors.modules_of_interest} />
          </div>

          <RecaptchaV2
            errors={errors}
            formData={formData}
            recaptchaError={recaptchaError}
            setRecaptchaError={setRecaptchaError}
            onInputChange={handleInputChange}
            onResetReady={setRecaptchaResetFunc}
          />

          <button
            type="submit"
            disabled={submissionStatus === 'submitting' || csrfHookInfo.isLoading || !csrfHookInfo.isCsrfReady || recaptchaError}
            className={`w-full font-medium py-4 px-4 rounded-lg transition-all duration-200
                    ${submissionStatus === 'submitting' || csrfHookInfo.isLoading || !csrfHookInfo.isCsrfReady || recaptchaError
      ? 'bg-gray-400 cursor-not-allowed'
      : 'bg-blue-600 hover:bg-blue-700 text-white hover:scale-105 hover:shadow-lg'
    }`}
          >
            {csrfHookInfo.isLoading ? 'Loading Security...' : submissionStatus === 'submitting' ? 'Scheduling...' : 'Schedule My BOSSS Demo'}
          </button>
        </form>
      </div>
    </div>
  );
}
